<template>
  <button v-if="row.status !== 'paid'" class="btn btn-block btn-sm btn-primary disabled" aria-disabled="true" disabled>Pending</button>
  <a v-else :href="$api + row.url" class="btn btn-block btn-sm btn-primary" download>Download</a>
</template>

<script>
export default {
  name: 'Download',
  props: ['row']
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/Download.vue